import { getMockExamActivity } from 'my-core/online-course-utils';

import LoadingPage from 'my-components/LoadingPage';

import StudentCoursePageActivity from './StudentCoursePageActivity';

export default function StudentCoursePageMockExam({
  assessments,
  course,
  currentUser,
  drawerOpen,
  fetching,
  fetchStatus,
  onlineCourses,
  onToggleDrawer,
  pathMatchData,
}) {
  if (fetching) {
    return <LoadingPage />;
  }
  const mockExamId = +pathMatchData.params.id;
  const mockExam = [...onlineCourses, ...assessments.flatMap(a => a.online_courses)].find(oc => oc.id === mockExamId);
  const mockExamActivity = getMockExamActivity(mockExam);
  return (
    <StudentCoursePageActivity
      activeComponent={{ type: 'activity', data: mockExamActivity }}
      activityTitle={mockExam.name}
      classPassId={mockExamId}
      course={course}
      currentUser={currentUser}
      drawerOpen={drawerOpen}
      fetching={fetching}
      fetchStatus={fetchStatus}
      onToggleDrawer={onToggleDrawer}
      pathMatchData={pathMatchData}
    />
  );
}
